import { createContext, useContext, useState, ReactNode } from "react";
import { AttachmentsDetailsError, OrgTypeEnum } from "~/typings/types";

interface AcceptPoliticsContextType {
	isAcceptPolitics: boolean;
	setIsAcceptPolitics: (val: boolean) => void;
	acceptPoliticsError: AttachmentsDetailsError | null;
	setAcceptPoliticsError: (err: AttachmentsDetailsError | null) => void;

	isAcceptPrivacy: boolean;
	setIsAcceptPrivacy: (val: boolean) => void;
	acceptPrivacyError: AttachmentsDetailsError | null;
	setAcceptPrivacyError: (err: AttachmentsDetailsError | null) => void;

	isAcceptPromo: boolean;
	setIsAcceptPromo: (val: boolean) => void;
	acceptPromoError: AttachmentsDetailsError | null;
	setAcceptPromoError: (err: AttachmentsDetailsError | null) => void;

	isPendingOffer: boolean;
	setIsPendingOffer: (val: boolean) => void;

	orgType?: OrgTypeEnum;
	clientId?: string | null;
}

export const AcceptPoliticsContext = createContext<AcceptPoliticsContextType | null>(null);

export const AcceptPoliticsProvider = ({
	children,
	orgType,
	clientId,
}: { children: ReactNode; orgType?: OrgTypeEnum; clientId?: string | null }) => {
	const [isAcceptPolitics, setIsAcceptPolitics] = useState(false);
	const [acceptPoliticsError, setAcceptPoliticsError] = useState<AttachmentsDetailsError | null>(null);

	const [isAcceptPrivacy, setIsAcceptPrivacy] = useState(false);
	const [acceptPrivacyError, setAcceptPrivacyError] = useState<AttachmentsDetailsError | null>(null);

	const [isAcceptPromo, setIsAcceptPromo] = useState(false);
	const [acceptPromoError, setAcceptPromoError] = useState<AttachmentsDetailsError | null>(null);

	const [isPendingOffer, setIsPendingOffer] = useState(false);

	return (
		<AcceptPoliticsContext.Provider
			value={{
				isAcceptPolitics, setIsAcceptPolitics,
				acceptPoliticsError, setAcceptPoliticsError,

				isAcceptPrivacy, setIsAcceptPrivacy,
				acceptPrivacyError, setAcceptPrivacyError,

				isAcceptPromo, setIsAcceptPromo,
				acceptPromoError, setAcceptPromoError,

				isPendingOffer, setIsPendingOffer,

				orgType,
				clientId,
			}}
		>
			{children}
		</AcceptPoliticsContext.Provider>
	);
};

export const useAcceptPolitics = () => {
	const ctx = useContext(AcceptPoliticsContext);
	if (!ctx) throw new Error("useAcceptPolitics must be used inside AcceptPoliticsProvider");
	return ctx;
};
